module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "alt": "Page 3",
      "src": "images/graphics_3.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.000000, 0.0000, 0.0000, 1.000000, 0,0)",
      "width": "738px"
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0101, 304.0587, 314.7481)",
      "-webkit-transform-origin": "0px 20.788692px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s1fs ",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "59px"
    }
  }, [_vm._v("Latifa")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s1fs s2ls",
    staticStyle: {
      "position": "absolute",
      "left": "60px",
      "width": "55px"
    }
  }, [_vm._v("Berry")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s1fs s3ls",
    staticStyle: {
      "position": "absolute",
      "left": "116px",
      "width": "57px"
    }
  }, [_vm._v("Kropf ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "-webkit-transform": "matrix(1.0000, 0.0000, 0.0000, 1.0101, 257.4464, 344.8994)",
      "-webkit-transform-origin": "0px 20.788692px",
      "height": "0px"
    }
  }, [_c('span', {
    staticClass: "s0ff s1fs s4ls",
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "width": "124px"
    }
  }, [_vm._v("photographs")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s1fs s5ls",
    staticStyle: {
      "position": "absolute",
      "left": "126px",
      "width": "26px"
    }
  }, [_vm._v("by")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s1fs s6ls",
    staticStyle: {
      "position": "absolute",
      "left": "154px",
      "width": "39px"
    }
  }, [_vm._v("Tod")]), _vm._v(" "), _c('span', {
    staticClass: "s0ff s1fs s3ls",
    staticStyle: {
      "position": "absolute",
      "left": "196px",
      "width": "65px"
    }
  }, [_vm._v("Cohen ")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5978117e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pg_3.vue
// module id = 60
// module chunks = 0